"use client";
import { Article } from "../modules/landing/components/layouts/article";
import { FAQRegistrationAndLogin } from "../modules/faq/faq-registration-and-login";
import { FAQAboutJooalan } from "../modules/faq/faq-about-jooalan";
import { FAQHowToSell } from "../modules/faq/faq-how-to-sell";
import { FAQHowToOrder } from "../modules/faq/faq-how-to-order";
import { FAQOrders } from "../modules/faq/faq-orders";
import { FAQPaymentAndRefund } from "../modules/faq/faq-payment-and-refund";
import { FAQOthers } from "../modules/faq/faq-others";

export default function FAQ() {
  return (
    <Article>
      <header className="text-center text-lg font-bold mb-6">
        Jooalan FAQ
      </header>

      <FAQAboutJooalan />
      <FAQRegistrationAndLogin />
      <FAQHowToSell />
      <FAQHowToOrder />
      <FAQOrders />
      <FAQPaymentAndRefund />
      <FAQOthers />

    </Article>
  );
}
